module.exports = __webpack_public_path__ + "09_mustache_silver.647dbd29.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/09_mustache_silver.png
// module id = Z6Nx
// module chunks = 0